import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const ImportContactsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "ImportContactsPage" */ "@circle-react/components/SettingsApp/ManageMembers/ImportContactsModal"
    ),
);

export const ImportContactsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <ImportContactsComponent />
  </Suspense>
);
